import { Sex } from 'types';

export const tagsSelectList = [
  { value: Sex.Male, label: 'Мужской' },
  { value: Sex.Female, label: 'Женский' },
  { value: Sex.None, label: 'Не указан' },
];
